import { useState, FormEvent } from 'react'

import { SelectedImage, HTMLInputEvent, SetState } from 'types'
import { validUrlRegexp } from 'regexps'
import InvalidPhoto from './InvalidPhoto'
import Preview from './Preview'
import { SearchForm } from './SearchForm'

export interface Props {
  stagedImages: SelectedImage[]
  selectedImages: SelectedImage[]
  setSelectedImages: SetState<SelectedImage[]>
  setStagedImages: SetState<SelectedImage[]>
  uploadImages: () => void
  onSuccess: () => void
  multiSelect?: boolean
  showSearchIcon?: boolean
  showSearchAffordance?: boolean
  showAddImage?: boolean
}

const UploadFromLink = ({
  selectedImages,
  stagedImages,
  multiSelect,
  setSelectedImages,
  setStagedImages,
  uploadImages,
  onSuccess,
  showSearchIcon = false,
  showSearchAffordance = true,
  showAddImage = false
}: Props) => {
  const [inputValue, setInputValue] = useState('')
  const [isValidUrl, setIsValidUrl] = useState(true)
  const stagedImage = stagedImages[0]

  const validateUrl = (inputValue: string) => {
    const isValid = validUrlRegexp.test(inputValue)

    setIsValidUrl(isValid)

    return isValid
  }

  const handleOnChange = (e: HTMLInputEvent) => {
    const value = e.target.value
    setInputValue(value)

    if (validateUrl(value)) {
      const image: SelectedImage = {
        url: value,
      }
      setStagedImages([image])
      setSelectedImages([image])
    } else {
      setStagedImages([])
      setSelectedImages([])
    }
  }

  const clearInput = () => {
    setInputValue('')
    setStagedImages([])
    setSelectedImages([])
  }

  const onSubmit = async (e?: FormEvent | KeyboardEvent) => {
    if (stagedImages.length === 0) return
    e?.preventDefault()

    setSelectedImages(stagedImages)
    uploadImages()
    if (selectedImages.length > 0) {
      onSuccess()
    }
  }

  return (
    <>
      <SearchForm
        placeholder="http://"
        query={inputValue}
        onChange={handleOnChange}
        onSubmit={onSubmit}
        clearQuery={clearInput}
        showSearchAffordance={showSearchAffordance}
        showIcon={showSearchIcon}
      />

      {!isValidUrl && inputValue && <InvalidPhoto />}

      {inputValue && stagedImage && isValidUrl && (
        <Preview
          stagedImages={stagedImages}
          selectedImages={selectedImages}
          setSelectedImages={setSelectedImages}
          multiSelect={multiSelect}
          showAddImage={showAddImage}
          useGrid={false}
        />
      )}
    </>
  )
}

export default UploadFromLink
